import React, { useState, useEffect } from "react";
import { Row, Col, Button, Form, Badge } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";

import SelectableCard from "./SelectableCard";
import "./DetalleOrden.css";
import TimeIntervalPicker from "./TimeIntervalPicker";
import HorizontalDatePicker from "../../HorizontalDatePicker";
import { onSnapshot } from "firebase/firestore";
const DetalleOrden = ({
  plati,
  anadidos,
  ingredientes,
  anadirPedido,
  handlebackPlatillos,
  detalleOrden,
}) => {
  const [nota, setNota] = useState("");
  const [ingredientesMostrar, setIngredientesMostrar] = useState([]);
  const [costosItems, setCostosItems] = useState([]);
  const [platillo, setPlatillo] = useState(plati);
  const [selectCostosItem, setSelectCostosItem] = useState(null);
  const [qty, setQty] = useState(1);
  const [seccionV, setSeccionV] = useState(100);
  const fecha = new Date();
  const fechaActual = fecha.toISOString().split("T")[0];
  fecha.setDate(fecha.getDate() + 7);
  const fechaFinalForm = fecha.toISOString().split("T")[0];
  const dias = [
    "domingo",
    "lunes",
    "martes",
    "miercoles",
    "jueves",
    "viernes",
    "sabado",
  ];
  const numeroDia = new Date().getDay();
  const [dispo, setDispo] = useState();
  const [reser, setReser] = useState();
  const nombreDia = dias[numeroDia === 7 ? 0 : numeroDia];
  const [restante, setRestante] = useState(0);
  const [selectedDate, setSelectedDate] = useState(fechaActual);
  const [selectedDay, setSelectedDay] = useState(nombreDia);
  const [selectedTime, setSelectedTime] = useState("");
  const [cantidad, setCantidad] = useState(1);

  const handleNota = (nota) => setNota(nota);
  const handleQty = (qty) => {
    let acum = 0;
    if (dispo && dispo[selectedDate] && dispo[selectedDate][selectedTime]) {
      acum = dispo[selectedDate][selectedTime];
    }
    if (reser && reser[selectedDate] && reser[selectedDate][selectedTime]) {
      acum += reser[selectedDate][selectedTime];
    }
    if (detalleOrden) {
      const itemtime = detalleOrden?.filter((ite) => {
        return (
          ite.selectedTime === selectedTime &&
          ite.id === platillo.id &&
          ite.selectedDate === selectedDate
        );
      });
      const cant = itemtime.reduce((acom, ita) => acom + ita.cantidad, 0);
      acum += cant;
    }
    if (
      ((platillo.limite && parseInt(restante) >= parseInt(qty)) ||
        !platillo.limite) &&
      (!(
        platillo.modo === "PREVENTA" || platillo.modo === "RECOGER CON HORARIO"
      ) ||
        parseInt(qty) <= parseInt(platillo?.maxOrd) - acum)
    ) {
      let tcantidad = qty;
      setQty(tcantidad);
    }
  };
  const handleAnadidos = (e, index) => {
    let newplat = {
      cantidad: e.target.value === "" ? "0" : e.target.value,
      precio: anadidos[index].free ? 0 : anadidos[index].precio,
      name: anadidos[index].name,
    };
    platillo.anadidos[anadidos[index].id] = newplat;
    console.log(platillo.anadidos);
  };

  useEffect(() => {
    if (plati) {
      onSnapshot(plati.refDoc, (doc) => {
        let datos = doc.data();
        datos.id = doc.id;
        datos.refDoc = doc.ref;
        setPlatillo(datos);
        setDispo(datos.fechas);
        setReser(datos.reservados);
      });
    }
  }, [plati]);

  useEffect(() => {
    let restante = platillo?.piezas;
    if (dispo && dispo[selectedDate]) {
      let acum = 0;
      Object.keys(dispo[selectedDate]).forEach((ittem) => {
        acum += dispo[selectedDate][ittem];
      });
      restante = restante - acum;
    }
    if (reser && reser[selectedDate]) {
      let acum = 0;
      Object.keys(reser[selectedDate]).forEach((ittem) => {
        acum += reser[selectedDate][ittem];
      });
      restante = restante - acum;
    }
    setRestante(restante);
    if (cantidad > restante) {
      setCantidad(restante);
    }
  }, [selectedDate, dispo, reser, platillo, cantidad]);

  const checkChange = (id, name, cantidad, categoria) => {
    console.log(
      "ID:" + id,
      "\n Name:" +
        name +
        "\n Cantidad:" +
        cantidad +
        "\n Categoria:" +
        categoria,
    );
    if (platillo.listaingredientes.hasOwnProperty(id)) {
      delete platillo.listaingredientes[id];
    } else {
      let suma = 0;
      Object.keys(platillo.listaingredientes)
        .filter((e) => platillo.listaingredientes[e].categoria === categoria)
        .forEach((key) => {
          suma += parseInt(platillo.listaingredientes[key].cantidad);
        });
      if (
        suma === parseInt(cantidad) &&
        !platillo.listaingredientes.hasOwnProperty(id)
      ) {
        alert("Ya cuentas con el maximo de ingredientes para la categoria");
        return;
      } else {
        let valores = platillo.listaingredientes;
        valores[id] = {
          name: name,
          categoria: categoria,
          cantidad: 1,
        };
      }
    }
  };

  //Arreglar el metodo como en movil
  const handleIngredientes = (id, name, cantidad, categoria) => {
    let e = document.getElementById(id);
    let valor = e.value;
    console.log(
      "ID:" + id,
      "\n Cantidad:" + cantidad + "\n Categoria:" + categoria,
    );
    console.log(ingredientesMostrar);
    let suma = 0;
    Object.keys(platillo.listaingredientes)
      .filter(
        (e) =>
          platillo.listaingredientes[e].categoria === categoria && e !== id,
      )
      .forEach((key) => {
        suma += parseInt(platillo.listaingredientes[key].cantidad);
      });
    let select = ingredientes.filter((e) => e.id === id);
    if (parseInt(e.value) > select[0].cantidad) {
      valor = select[0].cantidad;
      platillo.listaingredientes[id].cantidad = parseInt(valor);
      alert("Ya cuentas con la cantidad maxima de " + name);
    }
    if (
      (e.value !== valor && suma + parseInt(valor) > parseInt(cantidad)) ||
      (e.value === valor && suma + parseInt(e.value) > parseInt(cantidad))
    ) {
      alert("Ya cuentas con la cantidad maxima para la categoria");
      valor = parseInt(cantidad) - suma;
    }
    platillo.listaingredientes[id].cantidad = parseInt(valor);
    console.log(platillo.listaingredientes);
  };

  const toggleCategoria = (index) => {
    if (seccionV === index) {
      setSeccionV(100);
    } else {
      setSeccionV(index);
    }
  };

  const handleAgregar = () => {
    if (!selectCostosItem) {
      alert("Seleccione una presentacion del platillo.");
      return;
    }

    if (!qty || qty <= 0) {
      alert("Seleccione una cantidad valida.");
      return;
    }
    let flag = 0;
    let totalAnadidos = 0.0;
    if (
      platillo.categoriasPers &&
      platillo.categoriasPers.length > 0 &&
      platillo.personalizable
    ) {
      platillo.categoriasPers.forEach((val) => {
        let suma = 0;
        Object.keys(platillo.listaingredientes)
          .filter((e) => platillo.listaingredientes[e].categoria === val.nombre)
          .forEach((key) => {
            suma += parseInt(platillo.listaingredientes[key].cantidad);
            if (val.precios && Object.keys(val.precios).includes(key)) {
              totalAnadidos +=
                parseFloat(val.precios[key]) *
                parseInt(platillo.listaingredientes[key].cantidad);
              platillo.listaingredientes[key].costo = parseFloat(
                val.precios[key],
              );
            } else {
              platillo.listaingredientes[key].costo = 0;
            }
          });
        if (flag === 0 && suma < parseInt(val.ingredientes)) {
          alert("Selecciona la cantidad indicada para " + val.nombre + ".");
          flag++;
        }
      });
    }
    if (flag !== 0) {
      return;
    }

    if (platillo.anadidos) {
      Object.keys(platillo.anadidos).forEach((key) => {
        totalAnadidos +=
          parseFloat(platillo.anadidos[key].cantidad) *
          parseFloat(platillo.anadidos[key].precio);
      });
    }

    const updatedPlatillo = {
      cantidad: parseInt(qty),
      costo: selectCostosItem.costo,
      description: platillo.description,
      id: platillo.id,
      idv4: uuidv4(),
      img: platillo.img,
      name: platillo.name,
      ncosto: selectCostosItem.ncosto,
      note: nota,
      anadidos: platillo.anadidos,
      ingredientes: platillo.listaingredientes,
      npuntos: selectCostosItem.puntos,
      status: "PENDIENTE",
      totalAnadidos: totalAnadidos,
      total: selectCostosItem.costo * parseInt(qty),
      puntos: selectCostosItem.puntos * parseInt(qty),
    };
    if (platillo?.modo === "RECOGER CON HORARIO" && selectedTime !== "") {
      updatedPlatillo.recoger = new Date(`${selectedDate}T${selectedTime}`);
      updatedPlatillo.recoger.setMinutes(
        updatedPlatillo.recoger.getMinutes() - parseInt(platillo?.estimado),
      );
      updatedPlatillo.selectedTime = selectedTime;
      updatedPlatillo.selectedDate = selectedDate;
    } else if (platillo?.modo === "RECOGER CON HORARIO") {
      alert("Seleccione una hora para recoger su pedido");
      return;
    }
    if (platillo?.modo === "PREVENTA" && selectedTime !== "") {
      updatedPlatillo.recoger = new Date(`${selectedDate}T${selectedTime}`);
      updatedPlatillo.recoger.setMinutes(
        updatedPlatillo.recoger.getMinutes() - parseInt(platillo?.estimado),
      );
      updatedPlatillo.selectedTime = selectedTime;
      updatedPlatillo.selectedDate = selectedDate;
    } else if (platillo?.modo === "PREVENTA") {
      alert("Seleccione dia y hora para recoger su pedido");
      return;
    }
    updatedPlatillo.selectedDate = selectedDate;
    if (selectCostosItem.puntos) {
      updatedPlatillo.npuntos = selectCostosItem.puntos;
      updatedPlatillo.puntos = selectCostosItem.puntos * parseInt(qty);
    } else {
      updatedPlatillo.npuntos = 0;
      updatedPlatillo.puntos = 0;
    }
    handlebackPlatillos();
    anadirPedido(updatedPlatillo);
  };

  // const handleShow = (e) => {
  //   if (e.target.name === "SIngredientes") {
  //     let elem = document.getElementById("Anadidos");
  //     elem.hidden = true;
  //     elem = document.getElementById("Ingredientes");
  //     elem.removeAttribute("hidden");
  //   } else {
  //     let elem = document.getElementById("Ingredientes");
  //     elem.hidden = true;
  //     elem = document.getElementById("Anadidos");
  //     elem.removeAttribute("hidden");
  //   }
  // };

  const handleSelect = (optionValue) => {
    setSelectCostosItem(optionValue);
  };

  useEffect(() => {
    if (platillo) {
      platillo.anadidos = {};
      platillo.listaingredientes = {};
      if (platillo.especificos && platillo.ingesp) {
        setIngredientesMostrar(
          ingredientes.filter((e) => platillo.ingesp.includes(e.id)),
        );
      } else {
        setIngredientesMostrar(ingredientes);
      }
      let costos = [];
      if (platillo.ncosto1 && parseFloat(platillo.costo1) > 0) {
        costos.push({
          ncosto: platillo.ncosto1,
          costo: platillo.costo1,
          puntos: platillo.puntos1,
        });
      }
      if (platillo.ncosto2 && parseFloat(platillo.costo2) > 0) {
        costos.push({
          ncosto: platillo.ncosto2,
          costo: platillo.costo2,
          puntos: platillo.puntos2,
        });
      }
      if (platillo.ncosto3 && parseFloat(platillo.costo3) > 0) {
        costos.push({
          ncosto: platillo.ncosto3,
          costo: platillo.costo3,
          puntos: platillo.puntos3,
        });
      }
      console.log(costos);
      setCostosItems(costos);
    }
  }, [ingredientes, platillo]);

  return (
    <>
      <Row>
        <Badge
          bg="gray"
          style={{
            color: platillo?.modo ? "white" : "black",
            margin: "auto",
            fontSize: 12,
            fontWeight: "600",
            marginBottom: 10,
            marginTop: 10,
            paddingTop: 7,
            paddingBottom: 7,
            backgroundColor: platillo?.modo
              ? platillo?.modo === "PREVENTA"
                ? "purple"
                : platillo?.modo === "RECOGER CON HORARIO"
                  ? "brown"
                  : "orange"
              : "orange",
          }}
        >
          {platillo?.modo
            ? platillo?.modo === "PREVENTA"
              ? "PREVENTA DISPONIBLE"
              : platillo?.modo === "RECOGER CON HORARIO"
                ? "PEDIDO CON HORARIO PARA RECOGER"
                : "PEDIDO PARA HOY"
            : "PEDIDO PARA HOY"}
        </Badge>
        <h4>{platillo?.name}</h4>
        <h6>{platillo?.description}</h6>
        <Col xs={12} sm={12} md={12} lg={12} className="">
          <Form.Label>Presentacion</Form.Label>
          <Row>
            {costosItems.map((item, index) => (
              <div className="col-4">
                <SelectableCard
                  key={item.ncosto}
                  item={item}
                  selected={item === selectCostosItem}
                  onSelect={handleSelect}
                />
              </div>
            ))}
          </Row>
          <br />
        </Col>
        {platillo &&
          (platillo.modo === "PREVENTA" ||
            platillo.modo === "RECOGER CON HORARIO") && (
            <h2 style={{ fontSize: 16, fontWeight: 600 }}>
              Horarios para recoger:
            </h2>
          )}
        {platillo && platillo.modo === "PREVENTA" && (
          <HorizontalDatePicker
            startDate={fechaActual}
            endDate={fechaFinalForm}
            allowedDays={[
              platillo?.lunes?.active && 1,
              platillo?.martes?.active && 2,
              platillo?.miercoles?.active && 3,
              platillo?.jueves?.active && 4,
              platillo?.viernes?.active && 5,
              platillo?.sabado?.active && 6,
              platillo?.domingo?.active && 0,
            ]}
            onSelect={(date) => {
              setSelectedDate(date);
              let dare = new Date(date).getDay() + 1;
              if (dare === 7) {
                dare = 0;
              }
              setSelectedDay(dias[dare]);
              setSelectedTime("");
            }}
          />
        )}
        {platillo?.limite && restante <= 0 ? (
          <Badge
            style={{
              color: "white",
              marginHorizontal: "auto",
              fontSize: 16,
              fontWeight: "800",
              height: 50,
              paddingHorizontal: 15,
              marginTop: 10,
              backgroundColor: "red",
            }}
          >
            AGOTADO HOY
          </Badge>
        ) : (
          <>
            {platillo &&
            (platillo.modo === "PREVENTA" ||
              platillo.modo === "RECOGER CON HORARIO") &&
            ((platillo[selectedDay] && platillo[selectedDay].active) ||
              (platillo[nombreDia] && platillo[nombreDia].active)) ? (
              <TimeIntervalPicker
                startTime={
                  platillo?.modo === "RECOGER CON HORARIO"
                    ? platillo[nombreDia].inicio
                    : platillo[selectedDay].inicio
                }
                endTime={
                  platillo?.modo === "RECOGER CON HORARIO"
                    ? platillo[nombreDia].fin
                    : platillo[selectedDay].fin
                }
                interval={parseInt(platillo?.intOrd)}
                capacity={parseInt(platillo?.maxOrd)}
                estimado={parseInt(platillo?.estimado)}
                disponibilidad={dispo ? dispo[selectedDate] : undefined}
                seleccionados={detalleOrden?.filter((ite) => {
                  return (
                    ite.id === platillo.id && ite.selectedDate === selectedDate
                  );
                })}
                reservados={reser ? reser[selectedDate] : undefined}
                onSelect={(time) => {
                  setSelectedTime(time.timeJS);
                }}
                actual={selectedDate === fechaActual}
              />
            ) : (
              platillo?.modo === "RECOGER CON HORARIO" && (
                <>
                  <h1 style={{ fontSize: 16, fontWeight: 600, marginTop: 8 }}>
                    Disponible hasta el{" "}
                    {dias.find((value) => {
                      return (
                        platillo[value]?.active &&
                        dias.indexOf(value) > dias.indexOf(nombreDia)
                      );
                    }) ||
                      dias.find((value) => {
                        return (
                          platillo[value]?.active &&
                          dias.indexOf(value) < dias.indexOf(nombreDia)
                        );
                      })}
                  </h1>
                  <TimeIntervalPicker
                    startTime={
                      platillo[
                        dias.find((value) => {
                          return (
                            platillo[value]?.active &&
                            dias.indexOf(value) > dias.indexOf(nombreDia)
                          );
                        }) ||
                          dias.find((value) => {
                            return (
                              platillo[value]?.active &&
                              dias.indexOf(value) < dias.indexOf(nombreDia)
                            );
                          })
                      ]?.inicio
                    }
                    endTime={
                      platillo[
                        dias.find((value) => {
                          return (
                            platillo[value]?.active &&
                            dias.indexOf(value) > dias.indexOf(nombreDia)
                          );
                        }) ||
                          dias.find((value) => {
                            return (
                              platillo[value]?.active &&
                              dias.indexOf(value) < dias.indexOf(nombreDia)
                            );
                          })
                      ]?.fin
                    }
                    interval={60}
                    capacity={0}
                    estimado={parseInt(platillo?.estimado)}
                    actual={false}
                  />
                </>
              )
            )}
          </>
        )}
        <Row>
          {platillo?.personalizable &&
            platillo?.categoriasPers &&
            platillo?.categoriasPers.map((item, index) => {
              return (
                <Col md={6} style={{ marginBottom: 10 }}>
                  <Button
                    name="SIngredien"
                    style={{ width: "80%" }}
                    onClick={() => toggleCategoria(index)}
                  >
                    {item.nombre + " (" + item.ingredientes + ")"}
                  </Button>
                </Col>
              );
            })}
          {/* {platillo.personalizable &&
          ingredientes &&
          ingredientesMostrar.length > 0 ? (
            <Col md={6}>
              <Button
                name="SIngredientes"
                style={{ width: "80%" }}
                onClick={(e) => handleShow(e)}
              >
                Ingredientes
              </Button>
            </Col>
          ) : (
            <></>
          )} */}
          {anadidos && anadidos.length > 0 ? (
            <Col md={6}>
              <Button
                name="SAñadidos"
                style={{ width: "80%" }}
                onClick={() => toggleCategoria(99)}
              >
                Añadidos
              </Button>
            </Col>
          ) : (
            <></>
          )}
        </Row>
        <br />
        <br />
        {platillo?.personalizable &&
          platillo?.categoriasPers &&
          platillo?.categoriasPers.map((item, index) => {
            if (index === seccionV) {
              return (
                <Row id="Ingredientes">
                  <Form.Label>{item.nombre}</Form.Label>
                  <div
                    className="scrollcat"
                    id="ScrollAna"
                    style={{ marginLeft: "25px" }}
                  >
                    {ingredientes
                      .filter((e) => item.lista.includes(e.id))
                      .map((val, index) => (
                        <Row style={{ paddingTop: 3, alignItems: "center" }}>
                          <Col md={1} style={{ paddingLeft: "30px" }}>
                            <input
                              style={{ border: "1px solid", paddingTop: "0px" }}
                              className="form-check-input"
                              type="checkbox"
                              checked={platillo.listaingredientes?.hasOwnProperty(
                                val.id,
                              )}
                              onChange={() =>
                                checkChange(
                                  val.id,
                                  val.name,
                                  item.ingredientes,
                                  item.nombre,
                                )
                              }
                              id={"Ing" + index}
                            />
                          </Col>
                          <Col md={8}>
                            <label
                              className="lblqrdinamico"
                              style={{
                                paddingTop: "5px",
                                paddingLeft: "20px",
                              }}
                            >
                              {val.name}
                              {item.precios &&
                              Object.keys(item.precios).includes(val.id) ? (
                                "- $" + item.precios[val.id]
                              ) : (
                                <></>
                              )}
                            </label>
                          </Col>
                          <Col md={3}>
                            <Form.Control
                              type="number"
                              placeholder="Cantidad"
                              disabled={!platillo.listaingredientes[val.id]}
                              name={val.name}
                              id={val.id}
                              value={
                                platillo.listaingredientes[val.id]
                                  ? platillo.listaingredientes[val.id].cantidad
                                    ? platillo.listaingredientes[val.id]
                                        .cantidad
                                    : 1
                                  : 0
                              }
                              min={1}
                              onChange={() =>
                                handleIngredientes(
                                  val.id,
                                  val.name,
                                  item.ingredientes,
                                  item.nombre,
                                )
                              }
                            />
                          </Col>
                        </Row>
                      ))}
                  </div>
                </Row>
              );
            } else {
              return <></>;
            }
          })}
        {seccionV === 99 && (
          <Row id="Anadidos">
            <Form.Label>Añadidos</Form.Label>
            <div
              className="scrollcat"
              id="ScrollAna"
              style={{ marginLeft: "25px" }}
            >
              {anadidos.map((val, index) => (
                <Row style={{ paddingTop: 3 }}>
                  <Col md={1}>
                    <label
                      className="lblqrdinamico"
                      style={{
                        paddingTop: "5px",
                        paddingLeft: "20px",
                        width: "10px",
                      }}
                    >
                      {val.free || parseFloat(val.precio) <= 0
                        ? "Gratis"
                        : "$" + val.precio}
                    </label>
                  </Col>
                  <Col md={8}>
                    <label
                      className="lblqrdinamico"
                      style={{
                        paddingTop: "5px",
                        paddingLeft: "20px",
                        width: "10px",
                      }}
                    >
                      {val.name}
                    </label>
                  </Col>
                  <Col md={3}>
                    <Form.Control
                      type="number"
                      placeholder="Cantidad"
                      name={val.name}
                      value={platillo.anadidos ? platillo.anadidos[val] : 0}
                      min={0}
                      onChange={(e) => handleAnadidos(e, index)}
                    />
                  </Col>
                </Row>
              ))}
            </div>
          </Row>
        )}
        <Col xs={8} sm={8} md={8} lg={8} className="">
          <Form.Label>Nota</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Añade comentarios a tu pedido"
            onChange={(e) => handleNota(e.target.value)}
          />
        </Col>
        <Col xs={2} sm={2} md={2} lg={2}>
          <Form.Label>Cantidad</Form.Label>
          <Form.Control
            type="number"
            placeholder="cantidad"
            value={qty}
            min={0}
            onChange={(e) => handleQty(e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col className="alingright" xs={6} sm={6} md={6} lg={6}>
          <br />
          <Button variant="success" onClick={handleAgregar}>
            Añadir
          </Button>
        </Col>
        <Col className="alingleft" xs={6} sm={6} md={6} lg={6}>
          <br />
          <Button variant="primary" onClick={handlebackPlatillos}>
            Regresar
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default DetalleOrden;
